import { AuthState } from '@aws-amplify/ui-components';
import React, { useState } from 'react';

import SignUpForm from './SignUpForm';
import SignInForm from './SignInForm';
import ForgotPasswordForm from './ForgotPasswordForm';

type Props = {
  afterComplete: () => void;
  initialState:
    | AuthState.SignIn
    | AuthState.SignUp
    | AuthState.ForgotPassword
    | AuthState.ConfirmSignIn;
};

const AuthForm: React.FC<Props> = ({ initialState, afterComplete }) => {
  const [authState, setAuthState] = useState(initialState);

  switch (authState) {
    case AuthState.SignIn:
      return (
        <SignInForm
          showSignUpForm={() => setAuthState(AuthState.SignUp)}
          showResetPasswordForm={() => setAuthState(AuthState.ForgotPassword)}
          afterComplete={() => afterComplete()}
        />
      );
    case AuthState.SignUp:
      return (
        <SignUpForm
          showSignInForm={() => setAuthState(AuthState.SignIn)}
          afterComplete={() => afterComplete()}
        />
      );
    case AuthState.ForgotPassword:
      return (
        <ForgotPasswordForm
          showSignInForm={() => setAuthState(AuthState.SignIn)}
          afterComplete={() => afterComplete()}
        />
      );
    default:
      return <div>Not implemented</div>;
  }
};

export default AuthForm;
